// extracted by mini-css-extract-plugin
module.exports = {"arrow":"order-arrow_arrow__3aF6P","arrowTypeBi":"order-arrow_arrowTypeBi__6W0oO","descOrder":"order-arrow_descOrder__19kJK"};